import apiClient from '../utils/apiClient';

class TableService {
    // Get all tables for a restaurant
    async getTables(restaurantId) {
        const response = await apiClient.get(`/restaurants/${restaurantId}/tables`);
        return response;
    }

    // Get single table
    async getTable(restaurantId, tableId) {
        const response = await apiClient.get(`/restaurants/${restaurantId}/tables/${tableId}`);
        return response;
    }

    // Create new table
    async createTable(restaurantId, tableData) {
        const response = await apiClient.post(`/restaurants/${restaurantId}/tables`, tableData);
        return response;
    }

    // Update table
    async updateTable(restaurantId, tableId, tableData) {
        const response = await apiClient.patch(`/restaurants/${restaurantId}/tables/${tableId}`, tableData);
        return response;
    }

    // Delete table
    async deleteTable(restaurantId, tableId) {
        const response = await apiClient.delete(`/restaurants/${restaurantId}/tables/${tableId}`);
        return response;
    }

    // Download single QR code
    async downloadQRCode(restaurantId, tableId) {
        const response = await apiClient.get(`/restaurants/${restaurantId}/tables/${tableId}/qrcode`, {
            responseType: 'blob'
        });
        return response;
    }

    // Download bulk QR codes as ZIP
    async downloadBulkQRCodes(restaurantId, tableIds) {
        const response = await apiClient.post(`/restaurants/${restaurantId}/tables/qrcodes/bulk`, {
            tableIds
        }, {
            responseType: 'blob'
        });
        return response;
    }
}

const tableService = new TableService();
export default tableService;

